import { cx } from '@flowus/common/cx';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FC } from 'react';
import { getUnnamedUser } from 'src/common/const';
import { convertToLastEditTime } from 'src/common/utils/formatter';
import { usePageTotalCount } from 'src/hooks/page/use-page-word-count';
import { CollapseCount } from 'src/mind-map/component/collapse-count';
import { useGetPageId } from 'src/utils/getPageId';

export const UpdateUserInfo: FC<{
  className?: string;
  name?: string;
  updatedAt?: number;
  showWordCount?: boolean;
  showMindNodeCount?: boolean;
  isByAI?: boolean;
}> = ({ className, name, updatedAt, showWordCount, showMindNodeCount, isByAI }) => {
  const { t } = useAppTranslation();
  const pageId = useGetPageId();
  const { wordCount, blockCount } = usePageTotalCount(pageId);

  return (
    <div className={cx('px-4 pt-1 text-t5 text-grey3', className)}>
      {showWordCount && (
        <div>
          {t('stats.word_count')}: {wordCount}
        </div>
      )}
      <div>
        {t('stats.block_count')}: {blockCount}
      </div>
      {showMindNodeCount && (
        <div>
          <span>{t('stats.node_count')}: </span>
          <CollapseCount blockId={pageId} mindMapId={pageId} />
        </div>
      )}
      <div className={cx('text-ellipsis', { 'mt-3': showWordCount || showMindNodeCount })}>
        {t('editor.last_edited_by')} {name || getUnnamedUser()}
      </div>
      <div>
        {t('common.last_edited_at')} {convertToLastEditTime(updatedAt)}
      </div>
      {/* {isByAI && <AiAlert />} */}
    </div>
  );
};
